'use client';

import * as React from 'react';
import * as Sentry from '@sentry/nextjs';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  React.useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <title>Something went wrong | Savvy</title>
      </head>
      <body
        style={{
          margin: 0,
          fontFamily:
            'Roobert, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
          color: '#1E424C',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <p
            style={{
              fontSize: '0.875rem',
              fontWeight: 700,
              color: '#FCB22D',
              textTransform: 'uppercase',
              letterSpacing: '0.2em',
              marginBottom: '1rem',
            }}
          >
            Something went wrong
          </p>

          <h1
            style={{
              fontSize: 'clamp(2rem, 5vw, 3rem)',
              fontWeight: 500,
              letterSpacing: '-0.025em',
              lineHeight: 1.2,
              margin: '0 0 1rem',
            }}
          >
            We hit a snag
          </h1>

          <p
            style={{
              fontSize: '1.125rem',
              opacity: 0.6,
              maxWidth: '24rem',
              margin: '0 auto 2.5rem',
              lineHeight: 1.6,
            }}
          >
            An unexpected error occurred. Please try again.
          </p>

          <button
            onClick={reset}
            style={{
              backgroundColor: '#FCB22D',
              color: '#1E424C',
              border: '1.5px solid #1E424C',
              borderRadius: '9999px',
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              fontWeight: 500,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
